// DatePicker baseado em Shadcn (Popover + Calendar) — substitui <input type="date">
// Mantém o valor no formato 'YYYY-MM-DD' (string) para compatibilidade com o estado existente.
import React, { useState } from "react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { cn } from "../lib/utils";
import { Button } from "./ui/button";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

// Converte 'YYYY-MM-DD' para Date local (evita off-by-one por fuso horário)
function parseISODateLocal(s) {
  if (!s || typeof s !== "string") return undefined;
  const [y, m, d] = s.split("-").map(Number);
  if (!y || !m || !d) return undefined;
  return new Date(y, m - 1, d);
}

// Converte Date para 'YYYY-MM-DD' (local)
function toISODateLocal(date) {
  if (!date) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export const DatePicker = ({
  value = "",
  onChange = () => {},
  placeholder = "Selecione a data",
  minDate = "",
  className = "",
  id,
  disabled = false,
  fromYear = 1940,
  toYear = new Date().getFullYear() + 1,
  "data-testid": dataTestId,
}) => {
  const [open, setOpen] = useState(false);
  const selected = parseISODateLocal(value);
  const minDateObj = parseISODateLocal(minDate);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          id={id}
          type="button"
          variant="outline"
          disabled={disabled}
          data-testid={dataTestId || (id ? `${id}-datepicker` : undefined)}
          className={cn(
            "w-full justify-start text-left font-normal",
            !selected && "text-muted-foreground",
            className
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4 shrink-0 opacity-70" />
          {selected ? format(selected, "dd/MM/yyyy", { locale: ptBR }) : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => {
            onChange(d ? toISODateLocal(d) : "");
            setOpen(false);
          }}
          disabled={minDateObj ? { before: minDateObj } : undefined}
          captionLayout="dropdown-buttons"
          fromYear={fromYear}
          toYear={toYear}
          locale={ptBR}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};
